import alabama from './states/alabama.json'
import alaska from './states/alaska.json'
import alberta from './states/alberta.json'
import arizona from './states/arizona.json'
import arkansas from './states/arkansas.json'
import british_columbia from './states/british_columbia.json'
import california from './states/california.json'
import colorado from './states/colorado.json'
import connecticut from './states/connecticut.json'
import delaware from './states/delaware.json'
import florida from './states/florida.json'
import georgia from './states/georgia.json'
import idaho from './states/idaho.json'
import illinois from './states/illinois.json'
import indiana from './states/indiana.json'
import iowa from './states/iowa.json'
import kansas from './states/kansas.json'
import kentucky from './states/kentucky.json'
import louisiana from './states/louisiana.json'
import maine from './states/maine.json'
import manitoba from './states/manitoba.json'
import maryland from './states/maryland.json'
import massachusetts from './states/massachusetts.json'
import michigan from './states/michigan.json'
import minnesota from './states/minnesota.json'
import mississippi from './states/mississippi.json'
import missouri from './states/missouri.json'
import montana from './states/montana.json'
import nebraska from './states/nebraska.json'
import nevada from './states/nevada.json'
import new_brunswick from './states/new_brunswick.json'
import new_hampshire from './states/new_hampshire.json'
import new_jersey from './states/new_jersey.json'
import new_mexico from './states/new_mexico.json'
import new_york from './states/new_york.json'
import newfoundland_and_labrador from './states/newfoundland_and_labrador.json'
import north_carolina from './states/north_carolina.json'
import north_dakota from './states/north_dakota.json'
import northwest_territories from './states/northwest_territories.json'
import nova_scotia from './states/nova_scotia.json'
import nunavut from './states/nunavut.json'
import ohio from './states/ohio.json'
import oklahoma from './states/oklahoma.json'
import ontario from './states/ontario.json'
import oregon from './states/oregon.json'
import pennsylvania from './states/pennsylvania.json'
import prince_edward_island from './states/prince_edward_island.json'
import quebec from './states/quebec.json'
import rhode_island from './states/rhode_island.json'
import saskatchewan from './states/saskatchewan.json'
import south_carolina from './states/south_carolina.json'
import south_dakota from './states/south_dakota.json'
import tennessee from './states/tennessee.json'
import texas from './states/texas.json'
import utah from './states/utah.json'
import vermont from './states/vermont.json'
import virginia from './states/virginia.json'
import washington from './states/washington.json'
import west_virginia from './states/west_virginia.json'
import wisconsin from './states/wisconsin.json'
import wyoming from './states/wyoming.json'
import yukon from './states/yukon.json'

export const statesData = {
  "type": "FeatureCollection",
  "features": [
    alabama,
    alaska,
    alberta,
    arizona,
    arkansas,
    british_columbia,
    california,
    colorado,
    connecticut,
    delaware,
    florida,
    georgia,
    idaho,
    illinois,
    indiana,
    iowa,
    kansas,
    kentucky,
    louisiana,
    maine,
    manitoba,
    maryland,
    massachusetts,
    michigan,
    minnesota,
    mississippi,
    missouri,
    montana,
    nebraska,
    nevada,
    new_brunswick,
    new_hampshire,
    new_jersey,
    new_mexico,
    new_york,
    newfoundland_and_labrador,
    north_carolina,
    north_dakota,
    northwest_territories,
    nova_scotia,
    nunavut,
    ohio,
    oklahoma,
    ontario,
    oregon,
    pennsylvania,
    prince_edward_island,
    quebec,
    rhode_island,
    saskatchewan,
    south_carolina,
    south_dakota,
    tennessee,
    texas,
    utah,
    vermont,
    virginia,
    washington,
    west_virginia,
    wisconsin,
    wyoming,
    yukon
  ]
}
